module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAKVJREFUaEPtl1EKgDAMxdb7H7rinwqFQhhizb63suaFssX6+IqP33/ZwNsJmsDYBDIzr81FxJa0txQ9L24DTTdNoAKlQirUJKBCEJRTSIVUCBJQIQhw7hR6vmUgKHy8+k+UCdgAZn4v8L8EKED/A02Cc8doE0C5TYWaBFXIx1xTlWqbCqmQCkECKgQBOoXGKgTNaB/fplD7BnCjDUCA+LgJYISwwAEDH5AxdCC17AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/addicon.png
// module id = OTlP
// module chunks = 1